module.exports = {"pi":{"clientId":"0XDjm99GjbtlUJWkclfsay2EMX6aS0hC"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/prod.config.json
// module id = 831
// module chunks = 0